import UserStatusComponent from '../../components/Employees/UserStatus';
import {
  updateRole,
  rollBackUpdateStatus,
  getTableList,
  getRoles,
  getClientRoles,
  suspendUser,
  getClientAssignments,
  reassingAccountManager,
  rollBackReassign,
  getAccountManage,
  clearSuspendError
} from "../../actions/employees";
import {
  getBusinessUnitTeamMembers
} from "../../actions/Clients";
import {
  connect
} from 'react-redux';

const mapStateToProps = (state) => {
  const {tableList, account_manager, roles, clientRoles, ifUpdateRoleSuccess, client_assignments, ifReassignSuccess, suspend_error, client_assignments_error, team_member_options} = state.employees;
  const {clients, roleId, selected_client, userId, roleName} = state.app;
  const { client_team_members } = state.clients;
  const isAdminSelect = (typeof selected_client) === "string" && selected_client.indexOf("r-") >= 0
  return {
    roles : (roleId > 50) ? clientRoles : roles,
    clientRoles: clientRoles,
    tableList,
    ifUpdateRoleSuccess,
    roleId,
    userId,
    roleName,
    suspend_error,
    account_manager: account_manager.filter((item) => item.id !== 53 ),
    client_assignments,
    ifReassignSuccess,
    client_assignments_error,
    team_member_options,
    clients,
    client_team_members,
    selected_client: (clients !== undefined && isAdminSelect) && clients[0].id
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getRoles: () => {
      dispatch(getRoles());
    },
    getClientRoles: () =>{
      dispatch(getClientRoles())
    },
    // updateRole: (userId, roleId) => {
    //   dispatch(updateRole(userId, roleId))
    // },
    updateRole: (userId, roleId, isUpdateClient) => {
      dispatch(updateRole(userId, roleId, isUpdateClient))
    },
    rollBackUpdateStatus: () => {
      dispatch(rollBackUpdateStatus())
    },
    getTableList: (obj, clientId) => {
      dispatch(getTableList(obj, clientId));
    },
    getAccountManage: (id) => {
      dispatch(getAccountManage(id));
    },
    // suspendUser: (userId, status) => {
    //   dispatch(suspendUser(userId, status))
    // },
    suspendUser: (userId, status, isClientUser) => {
      dispatch(suspendUser(userId, status, isClientUser))
    },
    getClientAssignments: (id) => {
      dispatch(getClientAssignments(id))
    },
    reassingAccountManager: (id, obj) => {
      dispatch(reassingAccountManager(id, obj))
    },
    rollBackReassign: () => {
      dispatch(rollBackReassign())
    },
    clearSuspendError: () => {
      dispatch(clearSuspendError())
    },
    getBusinessUnitTeamMembers: (clientId, businessId) => {
      dispatch(getBusinessUnitTeamMembers(clientId, businessId));
    }
  }
}

const UserStatus = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserStatusComponent);

export default UserStatus;


// WEBPACK FOOTER //
// ./src/containers/Employees/user-status.js